/* WOOFGOLF — cart rules.
   - Delivery options (protection, priority) are toggles, quantity 1, shown only when a LED pack is in the cart.
   - No checkout without a LED pack : accessories and options alone are blocked (anti pre-order).
   - Option lines are hidden from the item list (the toggles already show them). */
(function () {
  'use strict';
  var box = document.querySelector('[data-lf-addons]');
  if (!box) return;
  var IDS = (box.getAttribute('data-ids') || '').split(',').filter(Boolean);
  var PACK = box.getAttribute('data-pack') || 'woofgolf-caddy-costume';
  var msg = document.querySelector('[data-lf-min]');
  var body = document.querySelector('[data-lf-cartbody]');
  var blocked = false, busy = false;

  function isOpt(id) { return IDS.indexOf(String(id)) > -1; }
  function post(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
  }
  function refresh() {
    var b = document.querySelector('[data-lf-open]');
    if (b) b.click(); else location.reload();
  }
  function setCheckout(off) {
    blocked = off;
    document.querySelectorAll('a[href$="/checkout"], button[name="checkout"], input[name="checkout"]').forEach(function (el) {
      el.classList.toggle('is-off', off);
      if (off) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled');
      if ('disabled' in el && el.tagName !== 'A') el.disabled = off;
    });
    if (msg) msg.hidden = !off;
  }
  function sync() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var hasPack = false, others = 0, fix = {}, present = {}, needFix = false;
      c.items.forEach(function (it) {
        if (isOpt(it.variant_id)) {
          present[it.variant_id] = true;
          if (it.quantity > 1) { fix[it.variant_id] = 1; needFix = true; }
        } else {
          others += it.quantity;
          if (it.handle === PACK) hasPack = true;
        }
      });
      /* options without a pack make no sense : remove them */
      if (!hasPack && Object.keys(present).length) {
        IDS.forEach(function (id) { if (present[id]) fix[id] = 0; });
        needFix = true;
      }
      if (needFix) { busy = true; post('/cart/update.js', { updates: fix }).then(function () { busy = false; refresh(); }); return; }

      box.hidden = !hasPack;
      box.querySelectorAll('[data-lf-ao]').forEach(function (cb) { cb.checked = !!present[cb.getAttribute('data-lf-ao')]; });
      setCheckout(others > 0 && !hasPack);
      if (body) body.querySelectorAll('.lf-li').forEach(function (li) {
        var rm = li.querySelector('[data-lf-rm]');
        var vid = rm ? String(rm.getAttribute('data-lf-rm')).split(':')[0] : '';
        li.style.display = isOpt(vid) ? 'none' : '';
      });
    }).catch(function () {});
  }

  box.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-lf-ao]');
    if (!cb) return;
    var id = cb.getAttribute('data-lf-ao'), lab = cb.closest('.pn-tg');
    if (lab) lab.classList.add('is-busy');
    busy = true;
    var req = cb.checked
      ? post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      : post('/cart/update.js', { updates: (function () { var u = {}; u[id] = 0; return u; })() });
    req.then(function () { busy = false; if (lab) lab.classList.remove('is-busy'); refresh(); })
       .catch(function () { busy = false; if (lab) lab.classList.remove('is-busy'); });
  });

  /* never let a cart without a LED pack reach checkout */
  function guard(e) {
    if (!blocked) return;
    var t = e.target.closest && e.target.closest('a[href$="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!t && !(e.type === 'submit' && e.submitter && e.submitter.name === 'checkout')) return;
    e.preventDefault(); e.stopPropagation();
    if (msg) { msg.hidden = false; msg.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 }); }
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  if (body && 'MutationObserver' in window) new MutationObserver(sync).observe(body, { childList: true });
  sync();
})();
